<template>
  <div>
    <label
      v-if="!noLabel"
      :class="
        id == 'kanban-unique'
          ? 'fw-500 teams-label-font'
          : id == 'cvsStatus'
          ? 'acs-input-head'
          : 'teams-label-font'
      "
      >{{ label }}<span v-if="mandatory" class="asterik">*</span></label
    >
    <div class="select-div">
      <div
        ref="landingdrop"
        tabindex="0"
        @focusin="handleFocusIn"
        @keydown="handleKeydown"
        @click="toggleDropdown"
        @mouseover="handleDropdownOpen"
        class="
          selectCustom-field
          d-flex
          align-items-center
          justify-content-between
        "
        :class="{
          selectbindingClass: disabled,
          error: showError,
          'teams-filter-inputField-disabled': disabled,
          'cursor-not-allowed': disableDropdown && disabled,
        }"
      >
        <span
          :class="
            placeholderText
              ? 'inputPlaceholder-font'
              : 'input-empty-placeholder'
          "
        >
          {{ placeholderText ? selectedObject.label : placeholder }}
        </span>
        <img
          v-if="!openDropdown"
          src="../../assets/cvsearch/cv-downarrow.svg"
          alt=""
          :class="{ 'arrow-disable-opacity': disabled }"
        />
        <img
          v-else
          class="pointer"
          src="../../assets/cvsearch/cv-uparrow.svg"
          alt=""
          :class="{ 'arrow-disable-opacity': disabled }"
        />
      </div>
      <div
        v-closable="{
          exclude: ['landingdrop'],
          handler: 'hideLandingDropdown',
        }"
        v-if="openDropdown"
        :class="from == 'scroll-filter' && 'overflow-xy'"
        :style="from == 'scroll-filter' && 'max-height: 98px !important;'"
        class="selectCustom-dropdown pointer"
      >
        <div
          class="selectCustom-dropdown-innerContent"
          v-for="(opt, index) in dropDownOptions"
          :key="index"
          :id="opt.key"
          @click.stop="
            !disabled && (selectedObject = opt),
              (selectedValue = opt.key),
              $emit('select-value', selectedValue),
              (openDropdown = false)
          "
          :class="{
            'selectCustom-opt-selected': isSelected(opt),
            'selectCustom-opt-unselected': !isSelected(opt),
          }"
          :tabindex="index === 0 ? 0 : -1"
        >
          {{ opt.label }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "SelectCustom",
  props: {
    selectbindingClass: String,
    disableDropdown: Boolean,
    disabled: Boolean,
    noLabel: Boolean,
    mandatory: Boolean,
    dropdown: Boolean,
    showError: Boolean,
    label: String,
    placeholder: String,
    id: String,
    api: String,
    fieldType: String,
    values: Array,
    from: String,
    type: String,
    vmodel: {
      validator: function () {
        return true;
      },
    },
  },
  data() {
    return {
      openDropdown: false,
      search: "",
      selectedValue: "",
      dropDownOptions: [],
      selectedObject: {},
      preventClose: false,
    };
  },
  computed: {
    ...mapGetters("userVUEX", {
      licenseKey: "getlicenseKey",
    }),
    placeholderText() {
      return Object.keys(this.selectedObject).length > 0;
    },
  },
  watch: {
    values(val) {
      this.dropDownOptions = val;
    },
    vmodel() {
      this.resetValues();
      this.$emit("select-value", this.selectedValue);
    },
  },
  created() {
    if (this.dropdown) {
      this.dropDownOptions = this.values;
    } else {
      this.getDropdownOptions();
    }
    this.resetValues();
  },
  mounted() {
    document.body.addEventListener("keydown", this.handleKeyPress);
  },
  beforeDestroy() {
    document.body.removeEventListener("keydown", this.handleKeyPress);
  },
  methods: {
    resetValues() {
      if (this.vmodel) {
        let type = typeof this.vmodel;
        this.selectedValue = type === "string" ? this.vmodel : this.vmodel.key;
        let selObject = this.dropDownOptions.find((obj) => {
          return obj.key === this.selectedValue;
        });
        if (selObject == undefined) {
          this.checkDefaultOption();
        } else {
          this.selectedObject = selObject;
        }
      } else {
        this.checkDefaultOption();
      }
    },
    handleTabKey(event) {
      if (!this.disableDropdown) {
        //  event.key === 'Tab'
        this.openDropdown = true;
        this.handleKeyPress(event);
      }
    },
    checkDefaultOption() {
      const defaultOption = this.dropDownOptions.find(
        (option) => option.isDefault
      );
      if (defaultOption) {
        this.selectedValue = defaultOption.key;
        this.selectedObject = defaultOption;
        this.$emit("select-value", this.selectedValue);
      }
    },
    handleKeyPress(event) {
      if (this.openDropdown && this.type != "filter") {
        const options = this.dropDownOptions;
        const selectedIndex = options.findIndex(
          (option) => option.key === this.selectedValue
        );
        if (event.key === "ArrowDown" && selectedIndex < options.length - 1) {
          this.selectedValue = options[selectedIndex + 1].key;
          this.selectedObject = options[selectedIndex + 1];
          const selectedOptionElement = document.getElementById(
            this.selectedValue
          );
          if (selectedOptionElement) {
            selectedOptionElement.scrollIntoView({
              behavior: "smooth",
              block: "nearest",
            });
          }
          this.$emit("select-value", this.selectedValue);
          event.preventDefault();
        } else if (event.key === "ArrowUp" && selectedIndex > 0) {
          this.selectedValue = options[selectedIndex - 1].key;
          this.selectedObject = options[selectedIndex - 1];
          const selectedOptionElement = document.getElementById(
            this.selectedValue
          );
          if (selectedOptionElement) {
            selectedOptionElement.scrollIntoView({
              behavior: "smooth",
              block: "nearest",
            });
          }
          this.$emit("select-value", this.selectedValue);
          event.preventDefault();
        } else if (event.key === "Enter") {
          if (!this.disabled) {
            this.openDropdown = false;
          }
        }
      }
    },
    async getDropdownOptions() {
      this.dropDownOptions = [];
    },
    hideLandingDropdown() {
      this.openDropdown = false;
    },

    isSelected(option) {
      return this.selectedObject && this.selectedObject.key === option.key;
    },

    handleFocusIn(event) {
      if (!this.disableDropdown && this.type != "filter") {
        this.openDropdown = true;
        this.handleKeyPress(event);
      }
    },
    handleKeydown(event) {
      if (event.key === "Tab" && this.type != "filter") {
        this.openDropdown = false;
      }
    },

    handleDropdownOpen() {
      if (!this.disableDropdown && this.type != "filter")
        this.preventClose = true;
    },

    toggleDropdown() {
      if (this.type != "filter") {
        if (!this.preventClose && !this.disableDropdown) {
          this.openDropdown = !this.openDropdown;
          this.preventClose = false; // Reset the flag here
        } else {
          this.preventClose = false; // Reset the flag here
        }
      } else this.openDropdown = !this.openDropdown;
    },
  },
};
</script>

<style scoped></style>
